import { Box, InputBase, List, ListItem, ListItemButton, useTheme } from '@mui/material';
import cx from 'classnames'; // Importing cx from classnames
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import { useDispatch, useSelector } from 'react-redux';
import { useGridFilter } from '../../../../../contexts/GridFilterContext';
import { updateFilter } from '../../../../../newapi/global/filter/gridFilterSlice';
import { useGetRelationsSelectQuery } from '../../../../../newapi/global/relation/relationSlice';
import { tokens } from '../../../../../theme';
import Text from '../../../../theme/text/Text';
import { ORDER_FILTER_KEYS } from '../../Filter';

const RelationFilter = ({params}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();
    const filterKey = params?.backend_key ?? ORDER_FILTER_KEYS.RELATION.backend_key;
    const dispatch = useDispatch();

    const { index,id } = useGridFilter();
    const filterObject = useSelector((state) => {
        const instance = state.gridFilter.viewInstances[index];
        return instance ? instance[id] : undefined;
    });
    const [searchTerm, setSearchTerm] = useState("");
    const [displayCount, setDisplayCount] = useState(50);
    const {data, isLoading, isFetching} = useGetRelationsSelectQuery();
    
    const { ref, inView } = useInView({
        threshold: 1.0, 
    });
    useEffect(() => {
        if (inView && data && data?.length) {
          setDisplayCount((prev) => Math.min(prev + 50, data.length));
        }
    }, [inView, data,data?.length]);

    const filteredData = useMemo(() => {
        return data?.filter((item) =>
          item.name?.toLowerCase().includes(searchTerm.toLowerCase())
        ) || [];
      }, [data, searchTerm]);
      
    const visibleData = useMemo(() => {
        return filteredData?.slice(0, displayCount) || [];
    }, [filteredData, displayCount]);

    // const allStates = Object.values(orderStateMap(theme));
    const handleStateToggle = (itemState) => {
        if (filterObject && filterObject.filter) {
            const currentState = filterObject.filter[filterKey] ?? -1;

            const updatedState = (currentState === itemState) ? -1 : itemState;
            dispatch(updateFilter({ index, id, filterKey, value: updatedState }));
        }
    };
  
    return (
        <Box
            sx={{
                display:"flex",
                flexDirection:"column",
                gap:1.5,
            }}
        >
            <Box
                sx={{
                    position:"sticky",
                    top:0,
                    zIndex:3,
                    width:1,
                    background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                    pb:1,

                }}
            >
                <Box
                    sx={{
                        height:32,
                        width:1,
                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                        borderRadius:4,
                        color:colors.txt['primary'],
                        fontSize:14,
                        display:"flex",
                        alignItems:"center",
                    }}
                >
                    <InputBase
                        onKeyDown={(e) => {
                            if(e.key === "Enter") {
                                setSearchTerm(e.target.value);
                            }
                        }}
                        onSubmit={(e) => {
                            setSearchTerm(e.target.value);
                        }}
                        placeholder={t("search")}
                        autoFocus
                        sx={{
                            // width:1,
                            flex:1,
                            height:32,
                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                            borderRadius:4,
                            px:2,
                            color:colors.txt['primary'],
                            fontSize:14,
                        }}
                    />
                </Box>
            </Box>
            <List
                sx={{
                    padding:0,
                    display:"flex",
                    flexDirection:"column",
                    gap:1.5,
                }}
            >
                {visibleData?.map((column, index) => (

                    <ListItem key={column.column + "indexrelation"+index} disablePadding 
                        onClick={() => handleStateToggle(column.id)}
                    >
                        <ListItemButton
                            className={cx({
                                active: filterObject && filterObject.filter?.[filterKey] === column.id
                            })}
                            sx={{
                                minWidth:250,
                                color:`${filterObject.sortedBy.length > 0 && filterObject.sortedBy[0].column === column.column ? theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400] : colors.txt["secondary"]}`,
                                fontWeight:`${filterObject.sortedBy.length > 0 && filterObject.sortedBy[0].column === column.column ? 500 : 400}`,
                                display:"flex",
                                justifyContent:"space-between",
                                fontSize:"14px",
                                pl:2,
                                pr:0.5,
                                height:40,
                                borderRadius:5,

                                background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                                border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                                "&.active" : {
                                    background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                    color:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],

                                }
                            }}
                        >
                            <Text>{column.name}</Text>
                        </ListItemButton>
                    </ListItem>
                    
                ))}

                {/* This is the invisible trigger element */}
                {visibleData?.length < data?.length && (
                    <div ref={ref} style={{ height: 1 }} />
                )}
            </List>
        </Box>
    );
};

export default RelationFilter;